import React, { useContext, useEffect, useState } from "react";

import { useRouter } from "next/router";

import cookie from "js-cookie";

import AuthContext from "shared/providers/context/AuthContext";
import GlobalContext from "shared/providers/context/GlobalContext";
import { clearCourseCache } from "shared/utils/clearCourseCache";
import setProductSession from "shared/utils/setProductSession";

import { EntityProps } from "../../@types/enrollments";
import switchContext from "../../utils/switchContext";
import BundlesOverlay from "./components/BundlesOverlay";
import ItemsToChooseBundle from "./components/ItemsToChooseBundle";

const ItemsToBuyBundles = ({
  entity,
  bundles,
  context,
  isContentScreen,
  isProductBundleScreen,
  isCourseLandingPageCard,
  isCourseLandingPageFooter,
}: ItemsToBuyBundlesProps) => {
  const router = useRouter();

  const { state } = useContext(GlobalContext);
  const { loggedUser } = useContext(AuthContext);

  const params = new URLSearchParams(window.location.search);

  const [showBundlesOverlay, setShowBundlesOverlay] = useState(false);

  const handlePurchase = (entityType, paramType, product) => {
    setProductSession(entityType, paramType, product);

    if (router.query.course_slug)
      clearCourseCache(router.query.course_slug as string);

    const checkoutOnePageDirectLinkSettingsOthers =
      state?.tenancy?.settings?.others?.checkoutOnePageProductPage === "1";
    const checkoutOnePageDirectLinkSettingsSite =
      state?.tenancy?.settings?.site?.checkoutOnePageProductPage === "1";

    const isCheckoutOnePage =
      checkoutOnePageDirectLinkSettingsOthers ||
      checkoutOnePageDirectLinkSettingsSite;

    if (isCheckoutOnePage) {
      router.push(`/payment/p/${product?.checkout_uuid}`);
    } else {
      if (!loggedUser) {
        const currentTime = new Date().getTime();
        const fiveMinutes = 7 * 60 * 1000;

        const expiresTime = new Date(currentTime + fiveMinutes);

        cookie.set("checkout_redirect", `/payment/p/${product.checkout_uuid}`, {
          expires: expiresTime,
        });

        return router.push("/authentication");
      }

      router.push(`/payment/p/${product?.checkout_uuid}`);
    }
  };

  const verifyContextAndGoToCheckout = () => {
    const { paramType, entityType } = switchContext({ context });

    handlePurchase(entityType, paramType, entity);
  };

  useEffect(() => {
    if (params.has("buy")) verifyContextAndGoToCheckout();
  }, [params]);

  return (
    <>
      <ItemsToChooseBundle
        isContentScreen={isContentScreen}
        lowestPrice={entity.lowest_price}
        isProductBundleScreen={isProductBundleScreen}
        isCourseLandingPageCard={isCourseLandingPageCard}
        setShowBundlesOverlay={setShowBundlesOverlay}
        isCourseLandingPageFooter={isCourseLandingPageFooter}
      />

      <BundlesOverlay
        entity={entity}
        bundles={bundles}
        context={context}
        handlePurchase={handlePurchase}
        showBundlesOverlay={showBundlesOverlay}
        setShowBundlesOverlay={setShowBundlesOverlay}
        individualSale={entity?.individual_sale !== 0}
      />
    </>
  );
};

interface ItemsToBuyBundlesProps {
  entity: EntityProps;
  bundles: any[];
  context: string;
  isContentScreen: boolean;
  isProductBundleScreen: boolean;
  isCourseLandingPageCard: boolean;
  isCourseLandingPageFooter: boolean;
}

export default ItemsToBuyBundles;
